/**
 * Safely converts various date formats to ISO string format
 */
export function safelyConvertDateToString(date: any): string | undefined {
    if (!date) return undefined

    try {
        // If it's already a string, return it
        if (typeof date === 'string') {
            return date
        }

        // If it's a native Date object
        if (date instanceof Date) {
            return date.toISOString().split('T')[0]
        }

        // If it's a Day.js object (has $d property)
        if (date.$d && date.$d instanceof Date) {
            return date.$d.toISOString().split('T')[0]
        }

        // If it's a Moment.js object (has toDate method)
        if (typeof date.toDate === 'function') {
            return date.toDate().toISOString().split('T')[0]
        }

        // If it has toISOString method
        if (typeof date.toISOString === 'function') {
            return date.toISOString().split('T')[0]
        }

        // Try to parse as Date
        const parsedDate = new Date(date)
        if (!isNaN(parsedDate.getTime())) {
            return parsedDate.toISOString().split('T')[0]
        }

        return undefined
    } catch (error) {
        console.warn('Failed to convert date:', date, error)
        return undefined
    }
}

/**
 * Safely converts various date formats to Date objects
 */
export function safelyConvertToDate(date: any): Date | undefined {
    if (!date) return undefined

    try {
        // If it's already a Date object
        if (date instanceof Date) {
            return date
        }

        // If it's a Day.js object (has $d property)
        if (date.$d && date.$d instanceof Date) {
            return date.$d
        }

        // If it's a Moment.js object (has toDate method)
        if (typeof date.toDate === 'function') {
            return date.toDate()
        }

        // If it's a string or number, try to parse
        const parsedDate = new Date(date)
        if (!isNaN(parsedDate.getTime())) {
            return parsedDate
        }

        return undefined
    } catch (error) {
        console.warn('Failed to convert to date:', date, error)
        return undefined
    }
} 